import { c as _c } from "react/compiler-runtime";
import { Shimmer } from '@onefootprint/ui';
const Loading = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <Shimmer height="150px" width="100%" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};

/** The onboardings panel's outline while the first page loads, so the page doesn't jump when it arrives. */
const PanelSkeleton = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="h-[32rem] rounded-lg bg-secondary p-1" aria-busy="true"><div className="flex h-full flex-col gap-4 rounded-default border border-solid border-tertiary bg-primary p-5"><Shimmer height="24px" width="240px" /><Shimmer height="16px" width="180px" /><Shimmer height="32px" width="100%" /></div></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};
export { PanelSkeleton };
export default Loading;